import apis from '@/apis/coreIAM/apis'
import { apisTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        fetchAll: {
            pending: false,
            error: null,
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [apisTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [apisTypes.FETCH_ALL_SUCCESS]: function (state, apis) {
            state.all = apis;
            state.fetchAll.error = null;
            state.fetchAll.pending = false;
        },
        [apisTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [apisTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [apisTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [apisTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [apisTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [apisTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [apisTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [apisTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [apisTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [apisTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [apisTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [apisTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [apisTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(apisTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .fetchAll()
                    .then((apisList) => {
                        commit(apisTypes.FETCH_ALL_SUCCESS, apisList.data)
                        resolve(apisList.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.FETCH_ALL_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchOne({ commit }, payload) {
            commit(apisTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .fetchOne(payload.uuid)
                    .then((api) => {
                        commit(apisTypes.FETCH_ONE_SUCCESS)
                        resolve(api.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(apisTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .createApi(
                        payload.id,
                        payload.name,
                        payload.description,
                        payload.url,
                        payload.redirectUris,
                        payload.webOrigins,
                    )
                    .then((api) => {
                        commit(apisTypes.CREATE_ONE_SUCCESS)
                        resolve(api.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(apisTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .updateApi(
                        payload.uuid,
                        payload.id,
                        payload.name,
                        payload.description,
                        payload.url,
                        payload.redirectUris,
                        payload.webOrigins,
                    )
                    .then((api) => {
                        commit(apisTypes.UPDATE_ONE_SUCCESS)
                        resolve(api.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(apisTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .deleteApi(payload.uuid)
                    .then(() => {
                        commit(apisTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(apisTypes.DELETE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },

    }
}